export default __webpack_public_path__ + "static/media/gitReact.504e9cad.png";